import { Analysis, PossibleRootCauseCategory } from '.';

export class InflammationOxidativeStressAnalysis extends Analysis {
    calculateInsights() {
        if (this.ba.albumin.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_13000);
        }

        if (this.ba.bilirubin.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_13010);
        }

        if (this.ba.ceruloplasmin.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_13020);
        }

        if (this.ba.hsCRP.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_13040);
        }

        // Ferritin above optimal splits on % saturation, because the two cases
        // want different supplements. Inflammation drives ferritin up while
        // saturation stays normal or low, and the supporting products there
        // include ascorbate carriers (CVO-R, ROX-2). Ferritin AND saturation
        // both high is the iron-overload picture instead, where ascorbate
        // increases non-heme iron absorption, so 13055 carries the same finding
        // without those two products.
        //
        // Saturation is only a discriminator when it was actually measured: it
        // is derived from iron / TIBC, and ~19% of the tests that report a
        // ferritin never report either. A blank saturation is not evidence of
        // overload, so it keeps the 13050 path rather than silently dropping
        // products from those tests.
        if (this.ba.ferritin.isGreaterThanOptimal()) {
            if (
                this.ba.saturation.hasValue() &&
                this.ba.saturation.isGreaterThanOptimal()
            ) {
                this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_13055);
            } else {
                this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_13050);
            }
        }

        if (this.ba.fibrinogen.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_13060);
        }

        if (this.ba.ggt.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_13070);
        }

        if (this.ba.hdl.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_13090);
        }

        if (this.ba.homocysteine.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_13110);
        } else if (this.ba.homocysteine.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_13120);
        }

        if (this.ba.tibc.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_13130);
        }

        if (this.ba.transferrin.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_13140);
        }

        if (this.ba.esr.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_13150);
        } else if (this.ba.esr.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_13160);
        }

        if (this.ba.uricAcid.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_13175);
        } else if (this.ba.uricAcid.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_13170);
        }
    }
}